<template>
    <div class="app-main-logo">
        <a :class="{ 'no-link': !link }" :href="getRoutePath('Home')" v-on:click.prevent="onLogoClick('Home')" @focus="onFocus">

            <div class="app-logo-inner">
                <img src="@/assets/images/logo/logo.svg" class="desktop_logo" alt="Ls logo">
                <img src="@/assets/images/logo/logo_mobile.svg" class="mobile_logo" alt="Ls logo">
            </div>

        </a>
    </div>
</template>

<script>
    import {mixinRoutesHandler} from '@/mixins/routes-handler';

    export default {
        name: 'AppMainLogo',

        props: {
            link: {
                default: true,
                type: Boolean,
            },
        },

        mixins: [mixinRoutesHandler],

        methods: {
            onClick() {
                this.$emit('onClick', true);
            },

            onFocus() {
                this.$emit('OnFocus', true);
            },

            getRoutePath(routeName) {
                return this._mixinGetRoutePath(routeName);
            },

            onLogoClick(routeName) {
                if (this.link) {
                    this.onClick();
                    this._mixinGoToRouteName(routeName);
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .app-main-logo {
        display: inline-block;

        .mobile_logo {
            display: block;
        }

        .desktop_logo {
            display: none;
        }

        @media (min-width: $lgBreakpoint) {
            .mobile_logo {
                display: none;
            }

            .desktop_logo {
                display: block;
            }
        }

    }
</style>
